import logo from './logo.svg';
import './App.css';
import ComingSoon from './Comingsoon';

function App() {
  return (
  <>
 <ComingSoon/>
  </>
  );
}

export default App;
